
<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs />
        <div class="table-agile-info">
          <!--查询条件-->
          <div class="common-new-title mode2">
            <span>AI 文本处理</span>
          </div>

          <el-form>
            <el-form-item label="">
              <el-tooltip
                v-for="item in promptList" :key="item.id"
                effect="dark" :content="item.intro">
                <el-radio
                  :disabled="loading"
                  v-model="promptObj"
                  :label="item"
                  class="prompt-radio"
                  border>
                  {{ item.title }}
                </el-radio>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="">
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-input
                    :disabled="loading"
                    placeholder="内容输入"
                    type="textarea"
                    v-model="chatContent"
                    rows="24"
                    clearable />
                </el-col>
                <el-col :span="12">
                  <el-input
                    placeholder="结果输出"
                    type="textarea"
                    v-model="respContent"
                    rows="24" />
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="">
              <el-row :gutter="10">
                <el-col :span="12" align="center">
                  <el-button @click="reset" :disabled="loading">清 空</el-button>
                  <el-button @click="chat" type="primary" :disabled="disabled">提 交</el-button>
                </el-col>
                <el-col :span="12" align="center">
                  <Copy :content="respContent" @copyCallback="copy()" style="display:inline;margin-left:10px">
                    <el-button type="warning" :disabled="disabled">复制结果</el-button>
                  </Copy>
                </el-col>
              </el-row>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';
import { EventStreamContentType, fetchEventSource } from '@microsoft/fetch-event-source';

const CHATGLM_API_URI = 'https://open.bigmodel.cn/api/paas/v3/model-api/chatglm_std/sse-invoke';

export default {
  data() {
    return {
      promptList: [], // 提示词列表
      promptObj: {}, // 提示词对象
      chatContent: '', // 问题
      respContent: '', // 回复

      jwtToken: '', // token
      loading: !false,
      abortController: null,
      eventSource: null,
    };
  },
  mounted() {
    this.getJWTToken();
    this.getPromptList();
  },
  methods: {
    chat(chatType) {
      this.chatType = chatType;
      this.respContent = ''; // 清空原来的问题
      if (this.chatContent) {
        this.chatWithAI();
      } else {
        this.$message.error('还没有添写加任何问题');
      }
    },
    /**
     * 获取对话 Body 数据
     */
    getChatBody() {
      let chatContent = `${this.promptObj.prompt}\n${this.chatContent}`;
      return JSON.stringify({
        prompt: [
          // {
          //   role: 'user',
          //   conent: '回答我的问题时请使用 markdown 格式，可以吗？'
          // },
          // {
          //   role: 'assistant',
          //   content: '没有问题，我在回答你的问题时使用 markdown 格式排版。'
          // },
          {
            role: 'user',
            content: chatContent,
          }
        ],
        temperature: this.promptObj.temperature,
        top_p: this.promptObj.top_p,
        incremental: true
      });
    },
    getPromptList() {
      this.loading = true;
      this.$http._get({
        url: '/index/smart_chat/listPrompt',
      }).then((res) => {
        this.loading = false;
        this.promptList = Object.assign({}, res.data);
        if (res.result !== 0) {
          this.$message.error(res.msg);
        }
      });
    },
    /**
     * 从流中解析 JSON 数据
     *
     * @param {ReadableStream} stream
     * @param json
     */
    async parseJsonFromStream(stream) {
      let text = '';
      let result;
      const reader = stream.getReader();
      const encode = new TextDecoder('utf-8');

      do {
        // eslint-disable-next-line no-await-in-loop
        result = await reader.read();
        text += encode.decode(result.value);
      } while (!result.done);
      reader.cancel(); // 取消读锁定

      return JSON.parse(text);
    },
    /**
     * 获取 token
     */
    getJWTToken() {
      this.$http._get({
        url: '/index/smart_chat/jwtToken',
      }).then((data) => {
        this.jwtToken = data.data;
      });
    },
    /**
     * 调用 AI 聊天接口
     */
    chatWithAI() {
      this.loading = true;
      this.abortController = new AbortController();

      let _that = this;
      this.eventSource = fetchEventSource(CHATGLM_API_URI, {
        openWhenHidden: true,
        method: 'POST',
        headers: {
          // Accept: 'text/event-stream',
          Authorization: _that.jwtToken,
          'Content-Type': 'application/json; charset=UTF-8',
        },
        body: this.getChatBody(),
        signal: this.abortController.signal,
        async onopen(response) {
          let contentType = response.headers.get('content-type');
          console.log(`Response ContentType: ${contentType}`);

          if (response.ok && contentType.startsWith(EventStreamContentType)) {
            console.info('SSE 启动正常');
          } else {
            let errMsg = '';
            if (response.status >= 400 && response.status < 500 && response.status !== 429) {
              errMsg = `请求状态错误！请刷新重试。(status = ${response.status})`;
            } else if (contentType === 'application/json') {
              let error = await _that.parseJsonFromStream(response.body);
              errMsg = `${error.msg}请刷新重试。`;
            } else {
              errMsg = '未知错误，请刷新重试。';
            }
            _that.$message.error(errMsg);
            _that.close(errMsg);
          }
        },
        onmessage(msg) {
          if (msg.event === 'add') {
            _that.respContent += msg.data;
          } else if (msg.event === 'finish') {
            _that.close('SSE 消息结束');
          } else if (msg.event === 'error' || msg.event === 'interrupted') {
            _that.close(`SSE 消息中断(${msg.event})`);
          } else {
            _that.close(`SSE 消息异常(${msg.event})`);
          }
        },
        onclose() {
          _that.close('SSE 连接已关闭');
        },
        onerror(err) {
          console.error(err);
          _that.close('SSE 发生错误');
        },
      });
    },
    close(log) {
      this.loading = false;
      this.abortController.abort();
      this.eventSource.close();
      console.log(log);
    },
    copy() {
      this.$message.success('复制成功');
    },
    reset() {
      this.chatContent = '';
      this.respContent = '';
    }
  },
  computed: {
    disabled() {
      return this.loading || !this.promptObj || !this.promptObj.id;
    }
  },
  components: {
    'jm-crumbs': crumbs,
  }
};
</script>
<style scoped>
.prompt-radio {
  margin:0 10px 10px 0 !important;
}
</style>

